(function () {
  'use strict';

  var dataEl = document.getElementById('lrp-page-data');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }
  if (!data || !data.trades) return;

  var tradeSelect    = document.getElementById('lrp-trade-select');
  var licenseSelect  = document.getElementById('lrp-license-select');
  var submitBtn      = document.getElementById('lrp-submit-btn');
  var contentBody    = document.getElementById('lrp-content-body');
  var contentSection = document.getElementById('lrp-content-section');
  var ctaWrap        = document.getElementById('lrp-content-cta');
  var ctaLink        = document.getElementById('lrp-cta-link');
  var form           = document.getElementById('lrp-selector-form');

  if (!tradeSelect || !licenseSelect || !submitBtn || !form) return;

  var defaultHTML = contentBody ? contentBody.innerHTML : '';

  function makeOpt(value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  function getTrade(val) {
    return data.trades.find(function (t) { return t.value === val; }) || null;
  }

  function getLicense(tradeVal, licVal) {
    var t = getTrade(tradeVal);
    return t ? (t.licenses.find(function (l) { return l.value === licVal; }) || null) : null;
  }

  function resetLicense() {
    licenseSelect.innerHTML = '';
    licenseSelect.appendChild(makeOpt('', 'Select License'));
    licenseSelect.disabled = true;
    submitBtn.disabled = true;
  }

  function populateLicenses(tradeVal) {
    resetLicense();
    var t = getTrade(tradeVal);
    if (!t || !t.licenses.length) return;
    t.licenses.forEach(function (l) { licenseSelect.appendChild(makeOpt(l.value, l.label)); });
    licenseSelect.disabled = false;
  }

  function showContent(tradeVal, licVal, scroll) {
    var lic = getLicense(tradeVal, licVal);
    if (!lic || !contentBody) return;
    contentBody.innerHTML = (lic.content && lic.content.trim())
      ? lic.content
      : '<p>No content available for this selection.</p>';
    if (ctaWrap && ctaLink) {
      if (lic.cta_text && lic.cta_url) {
        ctaLink.textContent = lic.cta_text;
        ctaLink.href = lic.cta_url;
        ctaWrap.style.display = '';
      } else {
        ctaWrap.style.display = 'none';
      }
    }
    if (scroll && contentSection) {
      setTimeout(function () {
        var stickyHeader = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
        var offset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 80;
        var top = contentSection.getBoundingClientRect().top + window.pageYOffset - offset - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 80);
    }
  }

  function restoreDefault() {
    if (contentBody) contentBody.innerHTML = defaultHTML;
    if (ctaWrap) ctaWrap.style.display = 'none';
  }

  function pushState(tradeVal, licVal) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('trade', tradeVal);
      url.searchParams.set('license', licVal);
      history.pushState({ trade: tradeVal, license: licVal }, '', url);
    } catch (_) {}
  }

  // Init trade dropdown
  data.trades.forEach(function (t) { tradeSelect.appendChild(makeOpt(t.value, t.label)); });

  tradeSelect.addEventListener('change', function () {
    populateLicenses(this.value);
  });

  licenseSelect.addEventListener('change', function () {
    submitBtn.disabled = !this.value;
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var tv = tradeSelect.value;
    var lv = licenseSelect.value;
    if (!tv || !lv) return;
    showContent(tv, lv, true);
    pushState(tv, lv);
  });

  window.addEventListener('popstate', function (e) {
    var s = e.state;
    if (s && s.trade && s.license) {
      tradeSelect.value = s.trade;
      populateLicenses(s.trade);
      licenseSelect.value = s.license;
      submitBtn.disabled = false;
      showContent(s.trade, s.license, false);
    } else {
      tradeSelect.value = '';
      resetLicense();
      restoreDefault();
    }
  });

  // Restore from URL params on first load, otherwise default to first trade + license
  var params = new URLSearchParams(window.location.search);
  var pt = params.get('trade');
  var pl = params.get('license');
  if (pt) {
    tradeSelect.value = pt;
    populateLicenses(pt);
    if (pl) {
      licenseSelect.value = pl;
      submitBtn.disabled = false;
      showContent(pt, pl, false);
    }
  } else if (data.trades.length) {
    var firstTrade = data.trades[0];
    tradeSelect.value = firstTrade.value;
    populateLicenses(firstTrade.value);
    if (firstTrade.licenses.length) {
      var firstLic = firstTrade.licenses[0];
      licenseSelect.value = firstLic.value;
      submitBtn.disabled = false;
      showContent(firstTrade.value, firstLic.value, false);
    }
  }
})();
